import React from "react"
import { composeSx } from "../theme/composeSx"
import {
  Radio,
  FormControlLabel,
  type RadioProps,
  type FormControlLabelProps,
} from "@mui/material"
import { colors } from "../theme/tokens"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type ViraRadioProps = RadioProps & {
  label?: React.ReactNode
  labelProps?: Omit<FormControlLabelProps, "control" | "label">
}

/** Radio control styled for Vira; safe outside `ViraThemeProvider`. */
export function ViraRadio({
  label,
  labelProps,
  disabled,
  sx,
  ...rest
}: ViraRadioProps) {
  const control = (
    <Radio
      disabled={disabled}
      sx={composeSx((theme) => {
        const vira = resolveViraPalette(theme)
        return {
          color: vira.softBorder,
          "&.Mui-checked": { color: colors.primary.shadow },
        }
      }, sx)}
      {...rest}
    />
  )
  if (label == null) return control
  return (
    <FormControlLabel
      control={control}
      label={label}
      disabled={disabled}
      {...labelProps}
    />
  )
}
